import { Box, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from "@mui/material";
import { JSXElementConstructor, Key, ReactElement, ReactNode, ReactPortal, useEffect, useState } from "react";
import { Button, useDataProvider, useNotify } from "react-admin";

// 物流信息弹窗组件
export const LogisticsDialog = ({ open, onClose, logisticsNo }) => {
    const [logisticsData, setLogisticsData] = useState(null);
    const [loading, setLoading] = useState(false);
    const notify = useNotify();
    const dataProvider = useDataProvider();

    useEffect(() => {
        if (open && logisticsNo) {
            fetchLogisticsInfo();
        }
    }, [open, logisticsNo]);

    const fetchLogisticsInfo = async () => {
        setLoading(true);
        try {
            const response = await dataProvider.expressInfo({ num: logisticsNo });
            setLogisticsData(response.data);
        } catch (error) {
            notify("获取物流信息失败", { type: "error" });
            console.error("获取物流信息失败:", error);
        } finally {
            setLoading(false);
        }
    };

    // 快递状态映射
    const getStatusText = (status: string | number) => {
        const statusMap = {
            "0": "在途",
            "1": "揽收",
            "2": "疑难",
            "3": "签收",
            "4": "退签",
            "5": "派件",
            "6": "退回",
        };
        return statusMap[status] || "未知状态";
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                物流信息 - {logisticsNo}
            </DialogTitle>
            <DialogContent>
                {loading ? (
                    <Box display="flex" justifyContent="center" p={3}>
                        <CircularProgress />
                    </Box>
                ) : logisticsData ? (
                    <Box>
                        <Box display="flex" alignItems="center" mb={2}>
                            <Typography variant="body1" mr={1}>
                                快递公司: {logisticsData.com}
                            </Typography>
                            <Chip
                                label={getStatusText(logisticsData.status)}
                                color={
                                    logisticsData.status === "3" ? "success" :
                                        logisticsData.status === "0" ? "primary" : "default"
                                }
                                size="small"
                            />
                        </Box>

                        <Divider sx={{ my: 2 }} />

                        <Typography variant="h6" gutterBottom>
                            物流轨迹
                        </Typography>

                        <Box maxHeight="400px" overflow="auto">
                            {logisticsData.content && logisticsData.content.length > 0 ? (
                                logisticsData.content.map((item: { time: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; status: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; }, index: Key | null | undefined) => (
                                    <Box key={index} mb={2} p={1} sx={{ borderLeft: "2px solid #ddd", pl: 2 }}>
                                        <Typography variant="body2" color="textSecondary">
                                            {item.time}
                                        </Typography>
                                        <Typography variant="body1">
                                            {item.status}
                                        </Typography>
                                    </Box>
                                ))
                            ) : (
                                <Typography variant="body2" color="textSecondary">
                                    暂无物流信息
                                </Typography>
                            )}
                        </Box>
                    </Box>
                ) : (
                    <Typography variant="body2" color="textSecondary">
                        暂无物流信息
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>关闭</Button>
            </DialogActions>
        </Dialog>
    );
};